export const STATISTICS_PATH = "/statistics";
export const STATISTICS_TAB_PARAM = "tab";

export const STATISTICS_TABS = {
  EXERCISE: "exercise",
  EXAM: "exam",
  PUBLIC: "public",
};

// Tab order determines the index used by MUI <Tabs> in MyStatistics.
export const STATISTICS_TAB_ORDER = [
  STATISTICS_TABS.EXERCISE,
  STATISTICS_TABS.EXAM,
  STATISTICS_TABS.PUBLIC,
];

export const DEFAULT_STATISTICS_TAB = STATISTICS_TABS.EXERCISE;

export const getStatisticsTabIndex = (tab) => {
  const idx = STATISTICS_TAB_ORDER.indexOf(tab);
  return idx >= 0 ? idx : 0;
};

export const getStatisticsTabKey = (index) =>
  STATISTICS_TAB_ORDER[index] || DEFAULT_STATISTICS_TAB;

export const buildStatisticsPath = (tab) => {
  if (!tab || tab === DEFAULT_STATISTICS_TAB) return STATISTICS_PATH;
  return `${STATISTICS_PATH}?${STATISTICS_TAB_PARAM}=${tab}`;
};
